import {
  checkEParavoloAVathmias,
  checkEParavoloBVathmias,
  eParavoloAVathmias,
  eParavoloBVathmias,
  NEO_PARAVOLO,
  PLIROMENO_PARAVOLO,
  PLIROMI_SE_EKSELIKSI_PARAVOLO,
} from "../constants";

export const errorMessageParse = (errorStatus) => {
  switch (errorStatus) {
    case 500:
      return "A network error occured, please try again later";
    case 409:
      return "eParavolo_has_not_been_paid";
    default:
      return;
  }
};

export const eParavoloStatusPayment = (status) => {
  switch (status) {
    case 1:
      return "eParavolo_not_payed";
    case 3:
      return "eParavolo_bound";
    case 4:
      return "eParavolo_cancelled";
    case 5:
      return "eParavolo_Payment_Processing";

    default:
      return;
  }
};

export const eParavoloCreateButtonDisabledStatus = (data) => {
  const statusParavolo = [
    NEO_PARAVOLO,
    PLIROMENO_PARAVOLO,
    PLIROMI_SE_EKSELIKSI_PARAVOLO,
  ];

  if (
    data?.status === eParavoloAVathmias &&
    statusParavolo.includes(parseInt(data?.paravolo_status_id_a))
  ) {
    return true;
  }

  if (
    data?.status === eParavoloBVathmias &&
    statusParavolo.includes(parseInt(data?.paravolo_status_id_b))
  ) {
    return true;
  }

  return false;
};

export const getIsEParavoloPliromeno = (data) => {
  const statusParavolo = [PLIROMENO_PARAVOLO];
  if (
    data?.status === eParavoloAVathmias ||
    data?.status === eParavoloBVathmias
  ) {
    return (
      statusParavolo.includes(parseInt(data?.paravolo_status_id_a)) ||
      statusParavolo.includes(parseInt(data?.paravolo_status_id_b))
    );
  } else {
    return true;
  }
};

export const getParavoloByStatusBackOffice = (data) => {
  if (data?.status === checkEParavoloAVathmias) {
    return {
      paravolo_payment_code: data?.paravolo_payment_code_a,
      paravolo_rf_code: data?.paravolo_rf_code_a,
      paravolo_status_id: data?.paravolo_status_id_a,
    };
  }

  if (data?.status === checkEParavoloBVathmias) {
    return {
      paravolo_payment_code: data?.paravolo_payment_code_b,
      paravolo_rf_code: data?.paravolo_rf_code_b,
      paravolo_status_id: data?.paravolo_status_id_b,
    };
  }
};
